import { render, staticRenderFns } from "./TenantsView.vue?vue&type=template&id=48a45f10&scoped=true"
import script from "./TenantsView.vue?vue&type=script&lang=js"
export * from "./TenantsView.vue?vue&type=script&lang=js"
import style0 from "./TenantsView.vue?vue&type=style&index=0&id=48a45f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a45f10",
  null
  
)

export default component.exports